import { render } from "./PersonCardNew.vue?vue&type=template&id=a047979e&scoped=true"
import script from "./PersonCardNew.vue?vue&type=script&lang=js"
export * from "./PersonCardNew.vue?vue&type=script&lang=js"

import "./PersonCardNew.vue?vue&type=style&index=0&id=a047979e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a047979e"]])

export default __exports__